module.exports = __webpack_public_path__ + "static/media/HomePic1.2ebda0a7.jpg";